import AxiosClient from "../AxiosClient";

export const getReceipts = (params) => {
  const url = "/api/receipt/searchInfoList";
  return AxiosClient.post(url, params);
};

export const getReceiptById = (receiptId) => {
  const url = "/api/receipt/searchInfoList";
  const params = { receiptId };
  return AxiosClient.post(url, params);
};

export const addReceipt = (params) => {
  const url = "/api/receipt/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateReceipt = (params) => {
  const url = "/api/receipt/updateInfo";
  return AxiosClient.post(url, params);
};
